module.exports = __webpack_public_path__ + "1aa2c2cb343ef934f7c289a0fde1e0de.woff2";